var _defs, _path, _path2, _path3, _path4, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeveloped(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 700 550.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n        stroke-width: 0px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M278.8,246.7l-27,75.7c-.2.5-.6.8-1.2.8h-22.9c-.5,0-1-.3-1.2-.8l-27-75.7c-.3-.8.3-1.7,1.2-1.7h21.8c.5,0,1,.3,1.2.8l15.5,43.4,15.5-43.4c.2-.5.7-.8,1.2-.8h21.7c.9,0,1.5.9,1.2,1.7Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M318.3,246.3v75.7c0,.7-.6,1.2-1.3,1.2h-21.8c-.7,0-1.3-.5-1.3-1.2v-75.7c0-.7.6-1.3,1.3-1.3h21.8c.7,0,1.3.6,1.3,1.3Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M521.4,246.2h-21.8c-.7,0-1.3.6-1.3,1.2v2.4c0,.5-.5.8-.9.5-6.3-3.5-13.3-5.4-20.6-5.4-22.9,0-41.5,18.4-41.5,40.9s18.6,41,41.5,41,14.3-1.9,20.6-5.4c.4-.2.9,0,.9.5v1.1c0,.7.6,1.3,1.3,1.3h21.8c.7,0,1.3-.6,1.3-1.3v-75.7c0-.5-.6-1.1-1.3-1.1ZM480.5,304.7c-10.5,0-19.1-8.4-19.1-18.8s8.5-18.8,19.1-18.8,17.8,8.4,17.8,18.8-7.3,18.8-17.8,18.8Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M379.2,245c-7.2,0-14.3,1.9-20.6,5.4-.4.2-.9,0-.9-.5v-2.4c0-.7-.6-1.2-1.2-1.2h-21.9c-.7,0-1.2.6-1.2,1.2v101.5c0,.7.5,1.3,1.2,1.3h21.9c.7,0,1.2-.6,1.2-1.3v-26.9c0-.5.5-.8.9-.5,6.3,3.5,13.3,5.4,20.6,5.4,22.9,0,41.5-18.4,41.5-40.9s-18.6-41.1-41.5-41.1ZM375.4,304.8c-10.5,0-17.8-8.4-17.8-18.8s7.3-18.8,17.8-18.8,19.1,8.4,19.1,18.8-8.6,18.8-19.1,18.8Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M537.7,314.4c0-2,.7-3.8,2.1-5.2,1.4-1.4,3.1-2.2,5.1-2.2s3.7.7,5.1,2.2c1.4,1.4,2.1,3.2,2.1,5.2s-.7,3.7-2.1,5.1c-1.4,1.4-3.1,2.1-5.1,2.1s-3.7-.7-5.1-2.1-2.1-3.1-2.1-5.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M567.2,339.2v-60.2h11.5v6.8c1.6-2.8,3.5-4.8,5.8-6.2,2.3-1.4,5-2,8-2,5.9,0,10.5,1.9,13.8,5.8s5,9.3,5,16.3-1.7,12.1-5,16.2-7.8,6.1-13.2,6.1-6.1-.6-8.4-1.8c-2.3-1.2-4.3-3.1-5.9-5.8,0,1,.2,2.2.3,3.4,0,1.2,0,2.6,0,4.2v17.2h-12ZM578.2,299.6c0,3.7.9,6.7,2.8,8.7,1.8,2.1,4.4,3.1,7.7,3.1s5.9-1,7.7-3.1,2.8-5,2.8-8.7-.9-6.7-2.8-8.8c-1.9-2.2-4.5-3.2-7.7-3.2s-5.7,1.1-7.6,3.2c-2,2.2-2.9,5.1-2.9,8.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M624.6,320.4v-32h-5.8v-9.4h5.8v-13.8h12v13.8h5.8v9.4h-5.8v32h-12Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeveloped);
export default __webpack_public_path__ + "static/media/developed.d3068f734fd02f6a5e69387e904844fa.svg";
export { ForwardRef as ReactComponent };